import { experienceBuilderApi } from 'api'

export const fetchSkillsByName = (data: any) =>
  experienceBuilderApi.get<{ data: any[] }>('/marketing-capabilities/skills/list', {
    params: {
      ...data,
    },
  })
